<template>
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_30_285)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8 0.685547C3.58172 0.685547 0 4.26727 0 8.68555C0 13.1038 3.58172 16.6855 8 16.6855C12.4183 16.6855 16 13.1038 16 8.68555C16 4.26727 12.4183 0.685547 8 0.685547ZM8 5.01888C7.03487 5.01888 6.2666 5.78709 6.2666 6.75222H4.93327C4.93327 5.05067 6.2985 3.68555 8 3.68555C9.70153 3.68555 11.0667 5.05067 11.0667 6.75222C11.0667 7.95168 10.3783 8.97508 9.36487 9.48181C8.92873 9.69988 8.66667 10.1328 8.66667 10.6189H7.33333C7.33333 9.63828 7.8714 8.73781 8.7686 8.28928C9.35513 7.99595 9.7334 7.41941 9.7334 6.75222C9.7334 5.78709 8.96513 5.01888 8 5.01888ZM8.80013 12.8856C8.80013 13.3274 8.442 13.6856 8.00013 13.6856C7.55833 13.6856 7.2002 13.3274 7.2002 12.8856C7.2002 12.4437 7.55833 12.0856 8.00013 12.0856C8.442 12.0856 8.80013 12.4437 8.80013 12.8856Z"
        fill="#374151"
      />
    </g>
    <defs>
      <clipPath id="clip0_30_285">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(0 0.685547)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
